<template>
  <div class="app-container">
    <div class="wt-form-inputs-container">
      <div class="wt-form-inputs-content">
        <el-form size="small" :inline="true" class="wt-form-inputs">
          <el-form-item label="时间：">
            <el-date-picker v-model="form.dataTimeRange"
              type="datetimerange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" :unlink-panels="true">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="社区：">
            <el-select v-model="form.communityId" filterable placeholder="请选择">
                <el-option
                  v-for="item in communityOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
          </el-form-item>
          <el-button size="small" type="primary" @click="toClickAction('search')">查询</el-button>
          <el-button size="small"  @click="toClickAction('reset')">重置</el-button>
          <el-button size="small"  @click="exportChart('活跃度统计')">导出</el-button>
        </el-form>
      </div>
    </div>
    <div class="chart-tile-section">
      <div class="item">
        <div class="title">居民注册率=居民注册量/社区总户数</div>
        <div class="title">{{`居民注册率 = ${detail.userRegisteredCount} / ${detail.userCommunityCount}`}}</div>
        <div class="chart-tile-item">
          <div class="label">居民注册率：</div>
          <div class="value">{{detail.userRegisteredRate}}</div>
        </div>
      </div>
      <div class="item">
        <div class="title">户均投递量=sum(社区站点下垃圾投递量）/居民注册总数</div>
        <div class="title">{{`户均投递量 = ${detail.userDeliveryWeight} / ${detail.userRegisteredCount}`}}</div>
        <div class="chart-tile-item">
          <div class="label">户均投递量：</div>
          <div class="value">{{detail.userDeliveryRate}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './mixin.js'
export default {
  name: 'StatisticalAnalysisPoints',
  mixins: [mixin],
  data() {
    return {
      form: {
        dataTimeRange: [],
        communityId: ''
      },
      communityOptions: [],
      detail: {}
    }
  },
  created() {
    this.initCreated()
  },
  mounted() {
    const that = this
    window.addEventListener('resize', that.resizeView)
    this.initPage()
  },
  beforeDestroy() {
    const that = this
    window.removeEventListener('resize', that.resizeView)
  },
  methods: {
    initCreated() {
      this.$store.dispatch('queryCommunityNoPageList').then(res => {
        this.communityOptions = res
      })
    },
    // 初始化页面
    initPage() {
      this.activeStatistical()
    },
    toClickAction(type) {
      if (type === 'reset') {
        this.form = {
          dataTimeRange: [],
          communityId: ''
        }
      }
      this.initPage()
    },
    exportChart(name) {
      const that = this
      const timer = (new Date()).getTime()
      const fileName = (name || '工单') + timer + '.xlsx'
      this.$wtUtil.downloadFile({
        url: window.wtConst.BASE_API + '/modules/statisticalActive/activeStatisticalImport',
        data: this.form,
        fileName: fileName
      }).then((res) => {
        console.log('导出成功')
      }).catch((err) => {
        that.$message({ message: err, type: 'error' })
      })
    },
    // 统计
    activeStatistical() {
      this.$api.statistical.activity.activeStatistical(this.form).then(res => {
        this.$nextTick(() => {
          this.detail = res.data
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.chart-tile-section {
  .item {
    width: 50%;
    max-width: 460px;
    padding: 32px 0;
    font-size: 21px;
    font-weight: bold;
    & + .item {
      margin-left: 20px;
    }
    .title {
      font-size: 14px;
      text-align: center;
      margin-bottom: 10px;
    }
    .chart-tile-item {
      width: 100%;
      margin: 0;
    }
    &:nth-child(1) {
      .chart-tile-item {
        background: url('../../../assets/images/stat/bg-1.png') center no-repeat;
        background-size: 100% 100%;
      }
    }
    &:nth-child(2) {
      .chart-tile-item {
        background: url('../../../assets/images/stat/bg-2.png') center no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>
